import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { ChangeSpeedParams } from "../SlotGameType1";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
// namespace SlotGames
// {

	
	export class PandaQuest_2Screen extends SlotGameType1_2Screen 
	{
		////protected override freegameBonusFactory_2Screen: FreegameBonusFactory_2Screen = new PandaQuestFreegameBonusFactory_2Screen();
	
		protected override pickBonusFactory:PickBonusFactory = new PandaPickBonusFactory();

		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData)
		 {
			super(multigameParams, initData, "PandaQuest");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
			
		}
	}

	// class PandaQuestFreegame_2Screen extends FreegameBonus_2Screen
	// {
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 0;
	// 		this.spinnableReelsParams.bottomBorderWidth = 0;
	// 	}
		

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "90px";
	// 					this.picks[i].awardElem.style.left = "-7px";
	// 					this.picks[i].awardElem.style.top = "4px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 					this.picks[i].awardElem.style.fontSize = "50px";
	// 					this.picks[i].awardElem.style.left = "-7px";
	// 					this.picks[i].awardElem.style.top = "4px";
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}
	

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void 
	// 	{
	// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "go3v2.ttf", "." + this.resid.ScopedResourceName(["font"])));
	// 	}

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
	// 		// align award to be in the box, when box opens
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 600;
	// 		let displayHeight: number = 600;

	// 		let displayRects: PixelRect[] = 
	// 		[
	// 			new PixelRect(0, 320, displayWidth, displayHeight),
	// 			new PixelRect(331, 320, displayWidth, displayHeight),
	// 			new PixelRect(665, 320, displayWidth, displayHeight),
	// 			new PixelRect(999, 320, displayWidth, displayHeight),
	// 			new PixelRect(1323, 320, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(171, 86, 200, 513);
			
	// 		let awardRect = new PixelRect(0, 0, displayWidth, displayHeight);
			
	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}

	// 	//CREATE FOR ROTATE ONLY THE PICK ELEMENT
	// 	protected override PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

	// 		let pickGeometries: FreegamePickElemGeometry[] = this.PicksPositions();
	// 		this.canvasSprite = null;
	
	// 		for (let i = 0; i < 5; i++) {
	
	// 			let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("pick")).sprite.Copy();
	// 			//let canvasSprite: CanvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	// 			this.canvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	
	// 			let params: FreegamePickElementParams = new FreegamePickElementParams(
	// 				i, 
	// 				this.logGroup,
	// 				pickGeometries[i].displayRect, 
	// 				pickGeometries[i].pickRect, 
	// 				pickGeometries[i].awardRect, 
	// 				this.canvasSprite
	// 			);
					
	// 			let pick: FreegamePickElement = this.params.pickElementFactory.CreatePickElement(params);
	// 			//ROTATE PICK FOR FILL IMG
	// 			pick.pickElem.style.transform="rotate(45deg)";
	// 			pick.AddPickCallback((index: number) => this.OnPicked(index));
	// 			pick.AddFreegamePickAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
	// 			pick.AddRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));
	
	// 			pick.OnDisplayAwardCallback = () => this.audio.Play(this.resid.ScopedResourceName("pick"));
	// 			pick.OnDisplayRemainingCallback = () => this.audio.Replay(this.resid.ScopedResourceName("remaining"));
	
				
	// 			this.picks.push(pick);
	// 			this.picksContainer.appendChild(pick.View());
				
	// 		}
	// 	}
		

	// 	protected PrepareMessage(resourceManager: ResourceManager)
	// 	{
	// 		// super.PrepareMessage(resourceManager);

	// 		// //override dialog box message color
	// 		// this.introMessageContainer.style.color = "#fec600";

	// 		//this.pickElem.innerHTML = "BAMBO";
	// 	}
	// }



// then you make this class but change the name for evey game
	class PandaPickBonus extends PickBonus
	{
		public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
			throw new Error("Method not implemented.");
		}
	}

	class PandaPickBonusElement extends PickBonusElement
	{
	}
	


	class PandaQuestFreegamePickElement extends FreegamePickElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			this.awardElem.style.left = "-4px";
			this.awardElem.style.top = "2px";
			this.awardElem.style.fontSize ="150px";
			
		}

		protected override PreparePickedElement(): void
		{
			this.awardElem.style.color = "yellow";
			this.awardElem.style.fontSize = "150px";
			this.awardElem.style.fontWeight="bold";
		}

		protected override PrepareRemainingElement(): void
		{
			this.awardElem.style.removeProperty("color");
			this.awardElem.style.removeProperty("fontSize");
		}
	}


	// class PandaQuestFreegameBonusFactory_2Screen extends FreegameBonusFactory_2Screen
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus_2Screen 
	// 	{
	// 		return new PandaQuestFreegame_2Screen(gameName, params);
	// 	}
		
		
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new PandaQuestFreegamePickElement(params);
	// 	}
		
	// }

//This sectio yes
	class PandaPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new PandaPickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new PandaPickBonusElement(params);
		}
		
	}
// }



